export { createAkimaSplineInterpolator, computeAkimaPolyCoefficients } from "./Akima";
export { createCubicSplineInterpolator, computeCubicPolyCoefficients } from "./Cubic";
export { createLinearInterpolator, computeLinearPolyCoefficients } from "./Linear";
export { createNearestNeighborInterpolator } from "./NearestNeighbor";
import { createAkimaSplineInterpolator } from "./Akima";
import { createCubicSplineInterpolator } from "./Cubic";
import { createLinearInterpolator } from "./Linear";
import { createNearestNeighborInterpolator } from "./NearestNeighbor";
import { createLoessInterpolator } from "./Loess";
export function createInterpolator(interpolationMethod, xVals, yVals) {
    switch (interpolationMethod) {
        case "akima": return createAkimaSplineInterpolator(xVals, yVals);
        case "cubic": return createCubicSplineInterpolator(xVals, yVals);
        case "linear": return createLinearInterpolator(xVals, yVals);
        case "nearestNeighbor": return createNearestNeighborInterpolator(xVals, yVals);
        case "loess": return createLoessInterpolator({ xVals, yVals });
        default: throw new Error(`Unknown interpolation method "${interpolationMethod}".`);
    }
}
export function createInterpolatorWithFallback(interpolationMethod, xVals, yVals) {
    const n = xVals.length;
    let method = interpolationMethod;
    if (n < 5 && method == "akima") {
        method = "cubic";
    }
    if (n < 3 && method == "cubic") {
        method = "linear";
    }
    if (n < 2) {
        const c = (n == 1) ? yVals[0] : 0;
        return (_x) => c;
    }
    return createInterpolator(method, xVals, yVals);
}
//# sourceMappingURL=Index.js.map